module.exports = __webpack_public_path__ + "img/148.65aad4c0.jpg";